
























































































































































































































































































































































































import { AZNCONNECT_API } from "@/services/aznconnect-api";
import { MandateGroupListModel } from "@/types/aznconnect_api";
import { Component, Prop, Vue } from "vue-property-decorator";
import SecureElementViewModel from "@/models/security/zorgID/secureElementViewModel";
import { SecurityService } from "@/services/SecurityService";
import InformationCard from "@/components/InformationCard.vue";
import SecureElementComponent from "@/components/zorgID/SecureElementComponent.vue";

@Component({
  components: {
    "information-card": InformationCard,
    SecureElementComponent,
  },
})
export default class ListView extends Vue {
  mandateGroupDialog: boolean = false;
  loading: boolean = false;

  createMandateGroupName: string = "";

  addMandateGroupMemberUziNumber: any = "";
  addMandateGroupMemberFullName: any = "";

  secureElements: any = "";

  mandateGroupList: Array<MandateGroupListModel> = [];
  permissionToCreateMandates: boolean = false;

  mounted() {
    this.getPermission();
  }

  getPermission() {
    const vm = this;

    vm.loading = true;

    this.secureElements = SecurityService.getInstance();

    AZNCONNECT_API.get("/mandate/GetPermission", {
      params: {},
    }).then(
      function(response) {
        //Succes request
        vm.loading = false;
        vm.permissionToCreateMandates = response.data;

        //Able to create mandates, so list all the mandates
        if (vm.permissionToCreateMandates) {
          vm.loadDetails();
        }
      },
      function() {
        //Failed request
        vm.loading = false;
      },
    );
  }

  loadDetails() {
    const vm = this;

    vm.loading = true;

    AZNCONNECT_API.get("/mandate/list", {
      params: {},
    }).then(
      function(response) {
        //Succes request
        vm.loading = false;
        vm.mandateGroupList = response.data;
      },
      function() {
        //Failed request
        vm.loading = false;
      },
    );
  }

  mandateGroupMembersListTableHeaders() {
    var json = [
      { text: "Actie", value: "action", sortable: false },
      { text: "Laatst bijgewerkt", value: "updated", sortable: false },
      { text: "UZI-nummer", value: "UziNumber", sortable: false },
      { text: "Naam", value: "FullName", sortable: false },
    ];
    return json;
  }

  mandateGroupTokensListTableHeaders() {
    var json = [
      { text: "Actie", value: "action", sortable: false },
      { text: "Laatst bijgewerkt", value: "updated", sortable: false },
      { text: "Verval datum", value: "ExpirationDate", sortable: false },
      { text: "Ingetrokken op", value: "Revoked", sortable: false },
    ];
    return json;
  }

  createMandateGroup() {
    var me = this;

    AZNCONNECT_API.post(
      "mandate/CreateMandateGroup",
      "'" + me.createMandateGroupName + "'",
    ).then(
      function(response) {
        //trigger refresh by loading the list again
        me.loadDetails();

        //Close dialog and reset values
        me.closeMandateGroupDialog();
      },
      function() {
        //Failed request
        // eslint-disable-next-line no-console
        console.log("Failed to create mandate group");

        me.closeMandateGroupDialog();
      },
    );
  }

  closeMandateGroupDialog(): void {
    this.createMandateGroupName = "";
    this.mandateGroupDialog = false;
  }

  closeMandateGroupMemberDialog(mandateGroup: MandateGroupListModel): void {
    this.addMandateGroupMemberUziNumber = "";
    this.addMandateGroupMemberFullName = "";
    mandateGroup.showAddMember = false;
  }

  addMandateGroupMember(mandateGroup: MandateGroupListModel) {
    var me = this;

    AZNCONNECT_API.post("mandate/AddMandateGroupMember", {
      GroupId: mandateGroup.Id,
      UziNumber: this.addMandateGroupMemberUziNumber,
      UziFullName: this.addMandateGroupMemberFullName,
    }).then(
      function(response) {
        //trigger refresh by loading the list again
        me.loadDetails();

        //Close dialog and reset values
        me.closeMandateGroupMemberDialog(mandateGroup);
      },
      function() {
        //Failed request
        // eslint-disable-next-line no-console
        console.log("Failed to add mandate group member");

        //Close dialog and reset values
        me.closeMandateGroupMemberDialog(mandateGroup);
      },
    );
  }

  deleteMandateGroupMember(groupId: number, memberId: number): void {
    const vm = this;
    var url =
      "/mandate/DeleteGroupMember?groupId=" + groupId + "&memberId=" + memberId;
    AZNCONNECT_API.get(url, {
      params: {},
    }).then(
      function(response) {
        //trigger refresh by loading the list again
        vm.loadDetails();
      },
      function() {
        //Failed request
      },
    );
  }

  closeMandateGroupTokenDialog(mandateGroup: MandateGroupListModel): void {
    mandateGroup.showCreateNewMandate = false;
  }

  createMandateGroupTokenProfessionalSummary(
    mandateGroup: MandateGroupListModel,
  ) {
    var me = this;

    AZNCONNECT_API.post(
      "/mandate/CreateMandateGroupTokenProfessionalSummary",
      mandateGroup.Id,
    ).then(
      function(response) {
        //trigger refresh by loading the list again
        me.loadDetails();

        //Close dialog and reset values
        me.closeMandateGroupTokenDialog(mandateGroup);
      },
      function() {
        //Failed request
        // eslint-disable-next-line no-console
        console.log("Failed to Create Token");

        //Close dialog and reset values
        me.closeMandateGroupTokenDialog(mandateGroup);
      },
    );
  }

  deleteMandateGroupToken(groupId: number, tokenId: number) {
    const vm = this;
    var url =
      "/mandate/DeleteGroupToken?groupId=" + groupId + "&tokenId=" + tokenId;
    AZNCONNECT_API.get(url, {
      params: {},
    }).then(
      function(response) {
        //trigger refresh by loading the list again
        vm.loadDetails();
      },
      function() {
        //Failed request
      },
    );
  }

  deleteMandateGroup(groupId: number) {
    const vm = this;
    var url = "/mandate/DeleteGroup?groupId=" + groupId;
    AZNCONNECT_API.get(url, {
      params: {},
    }).then(
      function(response) {
        //trigger refresh by loading the list again
        vm.loadDetails();
      },
      function() {
        //Failed request
      },
    );
  }
}
